<template>
  <el-cascader class="ww100"
               ref="cascader"
               v-model="activePage"
               :options="pages"
               :props="{checkStrictly: true, children: 'children', value: 'id', label: 'name' }"
               @change="changeCategory">
  </el-cascader>

</template>

<script>
import LinkApi from '@/api/link.js'

export default {
  data () {
    return {
      /*是否正在加载*/
      loading: true,
      /*页面数据*/
      pages: [],
      /*选中的值*/
      activePage: []
    }
  },
  created () {
    this.getData()
  },
  methods: {
    /*获取自定义页面*/
    getData () {
      let self = this
      LinkApi.getAllGroupList({}, true)
        .then(res => {
          self.loading = false
          let list = res.data || []
          self.pages = list
          this.activePage = []
          self.autoType(list)
        })
        .catch(error => {
          self.loading = false
        })
    },
    /*自动选择类别*/
    autoType (list) {
      if (list.length > 0) {
        let item = list[0]
        this.activePage.push(item.id)
        if (item.children && typeof item.children != 'undefined' && item.children.length > 0) {
          this.autoType(item.children)
        } else {
          this.changeFunc(item)
        }
      }
    },
    /*选择类别*/
    changeCategory (e) {
      console.log(e)
      let item = this.$refs['cascader'].getCheckedNodes()
      this.changeFunc(item[0].data)
    },
    /*选中的值*/
    changeFunc (item) {
      let obj = {}
      obj.name = item.name
      obj.url = 'pages/product/list/group?groupId=' + item.id
      obj.type = '产品分组'
      this.$emit('changeData', obj)
    }
  }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/setlink/part/GProduct.vue